/**
 * Legalbus COP REST API 1.0
 * REST API for the Legalbus COP digital signature platform
 *
 * The version of the OpenAPI document: 2.30.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VideoidRejectionData } from './videoidRejectionData';


export interface VideoIdMeeting { 
    status?: VideoIdMeeting.StatusEnum;
    position?: number;
    provider?: VideoIdMeeting.ProviderEnum;
    rejectionData?: VideoidRejectionData;
    showOtpInput?: boolean;
}
export namespace VideoIdMeeting {
    export type StatusEnum = 'NO_OPERATORS' | 'OUT_OF_OPENING_TIMES' | 'QUEUE_LENGTH_REACHED' | 'QUEUED' | 'ASSIGNED' | 'COMPLETED' | 'REJECTED' | 'EXPIRED' | 'ESCALATED' | 'DEQUEUED' | 'CANCELED';
    export const StatusEnum = {
        NoOperators: 'NO_OPERATORS' as StatusEnum,
        OutOfOpeningTimes: 'OUT_OF_OPENING_TIMES' as StatusEnum,
        QueueLengthReached: 'QUEUE_LENGTH_REACHED' as StatusEnum,
        Queued: 'QUEUED' as StatusEnum,
        Assigned: 'ASSIGNED' as StatusEnum,
        Completed: 'COMPLETED' as StatusEnum,
        Rejected: 'REJECTED' as StatusEnum,
        Expired: 'EXPIRED' as StatusEnum,
        Escalated: 'ESCALATED' as StatusEnum,
        Dequeued: 'DEQUEUED' as StatusEnum,
        Canceled: 'CANCELED' as StatusEnum
    };
    export type ProviderEnum = 'OPENTOK';
    export const ProviderEnum = {
        Opentok: 'OPENTOK' as ProviderEnum
    };
}


